
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/auth/pages/login/login-pure.vue', {"login.caption":{"ru_RU":"Логин","en_US":"Login"},"email.caption":{"ru_RU":"Адрес эл. почты","en_US":"Email"},"password.caption":{"ru_RU":"Пароль","en_US":"Password"},"login.required":{"ru_RU":"Введите логин","en_US":"Enter login"},"email.required":{"ru_RU":"Введите адрес эл. почты","en_US":"Enter email"},"password.required":{"ru_RU":"Введите пароль","en_US":"Enter password"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component.options._i18n = makeI18n("src/modules/auth/pages/login/login-pure.vue", baseTranslation);
      Component.options.beforeCreate = addHook(Component.options.beforeCreate);
      delete Component.options._Ctor;
    }
  